const INITIAL_STATE = {
    data: null
}

const PedidosLicenciamentosReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'pedidosLicenciamentos': {

            return {
                ...state,
                data: action.payload.pedidosLicenciamentos,
                config: action.payload.config
            }
        }
        default: {
            return state
        }
    }
}

export default PedidosLicenciamentosReducer
